/** SLOC Updation's chooser: the desk (RSW / CSW / PSW), then Sub-bin wise or Crop Variety wise. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { slocDesksOf } from "@nexseed/shared";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { SlocChooserPage } from "@/features/warehouse/components/sloc-chooser-page";
import { slocDeskRedirect } from "@/features/warehouse/route-helpers";

const search = z.object({
  stage: z.enum(["raw", "condition", "pack"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/warehouse/sloc")({
  validateSearch: search,
  beforeLoad: ({ search }) => {
    // SLOC Updation answers to its desk toggles alone, "RSW SLOC Updation" … (user, 2026-10-13).
    const { can } = useAuth.getState();
    if (!slocDesksOf(can).length) throw redirect({ to: "/" });
    // One desk opens directly, as if its link were clicked; a desk without its toggle goes to one
    // that has it. Several desks and none asked: the chooser, listing only those.
    const sloc = slocDeskRedirect(search.stage);
    if (sloc)
      throw redirect({ to: "/warehouse/sloc", search: { stage: sloc } });
  },
  component: Page,
});

function Page() {
  const { stage } = Route.useSearch();
  return <SlocChooserPage key={stage ?? "desk"} stage={stage} />;
}
